module.exports = __webpack_public_path__ + "static/Logo Round Shadow-dd5d9b058bdd491db98d6dc50fd8fe09.svg";